<template>
    <div class="fondo">
        <v-container style="margin: 0 auto ; max-width: 65rem; width: 100%;">
            <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
                <div>
                    <v-card class="mb-4" style="color: #0F57AC;padding: 1.9rem !important;">
                        <h1 class="titulo-from">
                            CONTROL DE ENDOTOXINAS EN AGUAS PARA DIALISIS
                        </h1>
                    </v-card>
                    <el-form :model="encuestaForm" label-position="top" :rules="rules" ref="encuestaForm">
                        <v-card class="mb-4" v-if="modelView==1">
                            <h3 style="margin-bottom: 1rem;">INFORME DE MICROBIOLOGÍA</h3>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Método" :label-width="formLabelWidth" prop="metodo">
                                        <el-input v-model="encuestaForm.metodo" autocomplete="off" disabled></el-input>

                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Sensibilidad" :label-width="formLabelWidth"
                                        prop="sensibilidad">
                                        <el-input v-model="encuestaForm.sensibilidad" autocomplete="off"
                                            disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Fecha de muestreo" :label-width="formLabelWidth"
                                        prop="fecha_muestreo">
                                        <el-date-picker style="width: 100%;" v-model="encuestaForm.fecha_muestreo"
                                            type="date" placeholder="Fecha de Muestreo" :editable=false>
                                        </el-date-picker>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Lugar de toma" :label-width="formLabelWidth" prop="ipress">
                                        <el-select v-model="encuestaForm.ipress" filterable placeholder="IPRESS"
                                            style="width: 100%;" disabled>
                                            <el-option v-for="item in arrayClinica" :key="item.value"
                                                :label="item.descripCas" :value="item.id_cas">
                                            </el-option>
                                        </el-select>

                                    </el-form-item>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Ultrapura
                                    </h3>
                                    <el-form-item label="Nivel Máximo permitido" :label-width="formLabelWidth"
                                        prop="ultrapura_max">
                                        <el-input v-model="encuestaForm.ultrapura_max" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Purificada
                                    </h3>
                                    <el-form-item label="Nivel de Acción: " :label-width="formLabelWidth"
                                        prop="purificada_accion">
                                        <el-input v-model="encuestaForm.purificada_accion" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Purificada
                                    </h3>
                                    <el-form-item label="Nivel Máximo permitido" :label-width="formLabelWidth"
                                        prop="purificada_max">
                                        <el-input v-model="encuestaForm.purificada_max" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4" v-if="modelView==1">
                            <h3>RESULTADOS</h3>
                            <v-row style="margin-top: 1rem;">
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Salida de Osmosis (RODI)" :label-width="formLabelWidth"
                                        prop="osmosis_resultado">
                                        <el-select v-model="encuestaForm.osmosis_resultado" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Segundo Microfiltro" :label-width="formLabelWidth"
                                        prop="microfiltro_resultado">
                                        <el-select v-model="encuestaForm.microfiltro_resultado" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Retorno de Circulación" :label-width="formLabelWidth"
                                        prop="circulacion_resultado">
                                        <el-select v-model="encuestaForm.circulacion_resultado" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Sala 1" :label-width="formLabelWidth" prop="sala1">
                                        <el-select v-model="encuestaForm.sala1" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Sala 2" :label-width="formLabelWidth" prop="sala2">
                                        <el-select v-model="encuestaForm.sala2" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Sala 3" :label-width="formLabelWidth" prop="sala3">
                                        <el-select v-model="encuestaForm.sala3" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="6" md="6">
                                    <el-form-item label="Sala 4" :label-width="formLabelWidth" prop="sala4">
                                        <el-select v-model="encuestaForm.sala4" style="width: 100%;">
                                            <el-option v-for="item in arrayResultados" :key="item" :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                          <v-card class="mb-4" v-if="modelView==2">
                            <h3 style="margin-bottom: 1rem;">INFORME DE MICROBIOLOGÍA</h3>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Método" :label-width="formLabelWidth" prop="metodo">
                                        <el-input v-model="encuestaForm.metodo" autocomplete="off" disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Sensibilidad" :label-width="formLabelWidth"
                                        prop="sensibilidad">
                                        <el-input v-model="encuestaForm.sensibilidad" autocomplete="off"
                                            disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Fecha de muestreo" :label-width="formLabelWidth"
                                        prop="fecha_muestreo">
                                        <el-date-picker style="width: 100%;" v-model="encuestaForm.fecha_muestreo"
                                            type="date" placeholder="Fecha de Muestreo" :editable=false>
                                        </el-date-picker>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Lugar de toma" :label-width="formLabelWidth" prop="ipress">
                                        <el-select v-model="encuestaForm.ipress" filterable placeholder="IPRESS"
                                            style="width: 100%;" disabled>
                                            <el-option v-for="item in arrayClinica" :key="item.value"
                                                :label="item.descripCas" :value="item.id_cas">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Ultrapura
                                    </h3>
                                    <el-form-item label="Nivel Máximo permitido" :label-width="formLabelWidth"
                                        prop="ultrapura_max">
                                        <el-input v-model="encuestaForm.ultrapura_max" autocomplete="off"
                                            disabled><template #append> UE/ml </template>
                                        </el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Purificada
                                    </h3>
                                    <el-form-item label="Nivel de Acción: " :label-width="formLabelWidth"
                                        prop="purificada_accion">
                                        <el-input v-model="encuestaForm.purificada_accion" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Purificada
                                    </h3>
                                    <el-form-item label="Nivel Máximo permitido" :label-width="formLabelWidth"
                                        prop="purificada_max">
                                        <el-input v-model="encuestaForm.purificada_max" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                    </el-form>
                </div>
                <v-btn color="secondary" @click="modelView=1" v-if="modelView==1">Atras</v-btn>
                <v-btn color="primary" type="submit" @click="modelView=2" v-if="modelView==2">Siguiente</v-btn>
                <v-btn color="primary" type="submit" v-if="modelView==2">Enviar</v-btn>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
    data() {
        return {
            modelView:1,
            arrayResultados: ['<0.03 EU/mL', '>0.03 EU/mL', '<0.25 EU/mL', '>0.25 EU/mL'],
            arrayClinica: [],
            formLabelWidth: "15px",
            encuestaForm: {
                metodo: "Limulus Amebocyte Lysate (LAL) Semicuantitativo",
                ipress: 1,
                sensibilidad: "0.3 EU/mL",
                ultrapura_max: "0.03 EU/mL",
                purificada_accion: "0.125 EU/mL",
                purificada_max: "<0.25 EU/mL",
                fecha_muestreo: null,
                osmosis_resultado: null,
                microfiltro_resultado: null,
                circulacion_resultado: null,
                sala1: null,
                sala2: null,
                sala3: null,
                sala4: null
            },
            selectedSection: 'Su salud',
            valid: false,
            formData: {},
            rules: {
                required: v => !!v || "Este campo es obligatorio",
            },
            opcionesTabla1: ["Ninguna", "Leve", "Moderada", "Severa", "Extrema o no puede hacerlo"],
            opciones: ["Derecha", "Izquierda", "No Aplica"],
            respuestas: Array(12).fill(""),
        };
    },
    created() {
        this.loadIpress();
    },
    methods: {
        loadIpress() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_ipress/", { "tipoCas": 2 }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayClinica = res.data;
                        })
                        .catch((res) => {
                            /* this.dialog = false; */
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        alert() {
            Swal.fire({
                title: "¡Error!",
                text: "Debe completar los campos obligatorios.",
                icon: "info"
            });
            return;
        },
        submitForm() {
            console.log("envio formulario ", this.encuestaForm);
        },
    },
};
</script>

<style scoped>
/* Para tablets */
@media (max-width: 768px) {
    .titulo-from {
        font-size: 28px;
    }
}

/* Para celulares */
@media (max-width: 480px) {
    .card-titulo {
        padding: 1.4rem !important;
    }

    .titulo-from {
        font-size: 23px;
        line-height: 1.8rem;
    }
}

::v-deep .el-form-item__label {
    line-height: 0px !important;
}

.v-card {
    padding: 2rem;
    border-radius: 12px;
    background:
        linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 15%, rgb(255, 255, 255) 100%)
}

.fondo {
    background: url(https://cdn.forms.office.net/images/aio/wave-pattern-v1.svg) center top / cover no-repeat, linear-gradient(180deg, #0F57AC 0%, rgba(3, 98, 206, 0.935) 100%);
    background-attachment: fixed;
    /* Fija el fondo al hacer scroll */
}
</style>